import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { AppConstants } from '../shared/appconstants';
import { StorageService } from '../shared/services/token-storage.service';

@Injectable({
  providedIn: 'root',
})
export class RouteRedirectGuard implements CanActivate {
  appConstants: AppConstants = new AppConstants();

  constructor(
    private router: Router,
    private storage: StorageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): UrlTree {
    try {
      const routeType =
        route.data['routeType'] as string;

      let userProviderType: string | null = null;
      let userTypeDesc: string | undefined;

      try {
        userProviderType =
          this.storage.get(
            'LoggedInProviderType'
          );

        userTypeDesc =
          this.storage
            .get(
              'LoggedInUserTypeDesc'
            )
            ?.toLowerCase();
      } catch (error) {
        this.logError(
          'Route storage lookup failed',
          error
        );
      }

      if (routeType === 'home') {
        return this.getHomeRoute(
          userProviderType,
          userTypeDesc
        );
      } else if (routeType === 'help') {
        return this.getHelpRoute(
          userProviderType
        );
      } else if (
        routeType === 'contact'
      ) {
        return this.getContactRoute(
          userProviderType
        );
      }

      return this.router.createUrlTree([
        '/',
      ]);
    } catch (error) {
      this.logError(
        'Route redirect failed',
        error
      );

      return this.router.createUrlTree([
        '/',
      ]);
    }
  }

  private getHomeRoute(
    userProviderType: string | null,
    userTypeDesc: string | undefined
  ): UrlTree {
    try {
      if (
        userTypeDesc !==
          'organization admin' &&
        userTypeDesc !== 'super admin'
      ) {
        if (
          userProviderType ===
          this.appConstants.providerTypes.SCO
        ) {
          return this.router.createUrlTree([
            '/scoHomePage',
          ]);
        } else if (
          userProviderType ===
          this.appConstants.providerTypes.Demo
        ) {
          return this.router.createUrlTree([
            '/demoHomePage',
          ]);
        }
      }

      return this.router.createUrlTree([
        '/rsHomePage',
      ]);
    } catch (error) {
      this.logError(
        'Home route redirect failed',
        error
      );

      return this.router.createUrlTree([
        '/rsHomePage',
      ]);
    }
  }

  private getHelpRoute(
    userProviderType: string | null
  ): UrlTree {
    try {
      if (
        userProviderType ===
        this.appConstants.providerTypes.SCO
      ) {
        return this.router.createUrlTree([
          '/help-content',
        ]);
      } else if (
        userProviderType ===
        this.appConstants.providerTypes.Demo
      ) {
        return this.router.createUrlTree([
          '/coming-soon',
        ]);
      }

      return this.router.createUrlTree([
        '/rs-help',
      ]);
    } catch (error) {
      this.logError(
        'Help route redirect failed',
        error
      );

      return this.router.createUrlTree([
        '/rs-help',
      ]);
    }
  }

  private getContactRoute(
    userProviderType: string | null
  ): UrlTree {
    try {
      if (
        userProviderType ===
        this.appConstants.providerTypes.SCO
      ) {
        return this.router.createUrlTree([
          '/sco-contact',
        ]);
      } else if (
        userProviderType ===
        this.appConstants.providerTypes.Demo
      ) {
        return this.router.createUrlTree([
          '/coming-soon',
        ]);
      }

      return this.router.createUrlTree([
        '/rs-contact',
      ]);
    } catch (error) {
      this.logError(
        'Contact route redirect failed',
        error
      );

      return this.router.createUrlTree([
        '/rs-contact',
      ]);
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] = [];
      let currentError: unknown =
        error;
      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError = null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(' | ')}`
            : ''
        }`
      );
    } catch {
      console.error(context);
    }
  }
}